import { type QueryOptions } from '@tanstack/query-core'

import { type SiteEntity } from '@/libs/api'

import { type FetchSitesByDcIdQuery, fetchSitesByDcId } from '../api'
import { sitesQueryKeys } from '../query-keys'

/**
 * Select用のDCに紐づく地点一覧のQueryOptionsを返す
 */
export const getSitesByDcIdSelectQueryOptions = (
  query: FetchSitesByDcIdQuery
): Required<Pick<QueryOptions<SiteEntity[]>, 'queryKey' | 'queryFn'>> => {
  return {
    queryKey: sitesQueryKeys.selectByDcId(query),
    queryFn: async ({ signal }) => {
      const { data } = await fetchSitesByDcId(query, signal)
      return data
    }
  }
}
